import React from 'react';

class VBErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false,
      error: null
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    //console.log(error);
    console.log(errorInfo);
  }

  render() {
    if (this.state.hasError) {
      //Send to 500 error page, critical javascript error occured
      window.location.replace("/500");
    }

    return this.props.children;
  }
}


export default VBErrorBoundary;